module.exports = __webpack_public_path__ + "img/kein_bild.eda7da8f.jpg";